import { ProductOrderItem } from '@spike/order-model';
import { FunctionComponent } from 'react';
import OrderItem from './OrderItem';

export interface ProductItemProps {
    productItem: ProductOrderItem;
    className?: string;
}

export const ProductItem: FunctionComponent<ProductItemProps> = props => {
    return (
        <OrderItem
            type="Product"
            orderItem={props.productItem.orderItem}
            staff={props.productItem.staff}
            className={props.className}
        />
    );
};

export default ProductItem;
